// src/components/Footer.jsx
import { Link } from "react-router-dom";
import { Mail, MessageSquareText } from "lucide-react";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-10 border-t border-orange-100 dark:border-slate-800 bg-white/90 dark:bg-slate-950/90 backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
          {/* Left */}
          <div className="min-w-0">
            <div className="text-sm font-extrabold bg-gradient-to-r from-orange-600 to-amber-600 bg-clip-text text-transparent">
              Voice Of Prophecy Virtual School
            </div>
            <p className="mt-1 text-xs text-gray-600 dark:text-slate-300">
              © {year} Voice Of Prophecy
            </p>
          </div>

          {/* Middle */}
          <nav className="flex flex-wrap items-center gap-2">
            <Link
              to="/courses"
              className="px-3 py-2 rounded-xl text-xs font-semibold border border-orange-100 dark:border-slate-800 bg-orange-50 dark:bg-slate-900 text-orange-700 dark:text-slate-100 hover:shadow-sm transition"
            >
              Courses
            </Link>

            <Link
              to="/certificates"
              className="px-3 py-2 rounded-xl text-xs font-semibold border border-orange-100 dark:border-slate-800 bg-orange-50 dark:bg-slate-900 text-orange-700 dark:text-slate-100 hover:shadow-sm transition"
            >
              Certificates
            </Link>

            <Link
              to="/feedback"
              className="px-3 py-2 rounded-xl text-xs font-semibold border border-orange-100 dark:border-slate-800 bg-orange-50 dark:bg-slate-900 text-orange-700 dark:text-slate-100 hover:shadow-sm transition inline-flex items-center gap-2"
            >
              <MessageSquareText size={14} />
              Feedback
            </Link>
          </nav>

          {/* Right */}
          <div className="text-xs text-gray-500 dark:text-slate-400 flex flex-wrap items-center gap-3 sm:justify-end">
            <a
              href="mailto:support@vop.org"
              className="inline-flex items-center gap-2 hover:text-orange-600"
            >
              <Mail size={14} />
              info@vop.or.ke
            </a>

            <span className="text-gray-300 dark:text-slate-700">•</span>

            <span>
              Version: <span className="font-semibold">VOP-LMS</span>
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
